import { BaseSectionDashboard } from "./BaseSectionDashboard";
import { getDashboardConfig } from "./dashboardRegistry";

type TSectionDashboardProps = {
  sectionId: string | null;
  sectionName: string;
  description?: string | null;
  companyId?: string | null;
};

export function SectionDashboard({ sectionId, sectionName, description, companyId }: TSectionDashboardProps) {
  // Get the feature configuration for this section from the registry
  const enabledFeatures = getDashboardConfig(sectionId);

  return (
    <BaseSectionDashboard
      sectionId={sectionId}
      sectionName={sectionName}
      description={description}
      companyId={companyId}
      enabledFeatures={enabledFeatures}
    />
  );
}
